module.exports = __webpack_public_path__ + "static/media/noimage.268ac00e.jpg";